<template>
  <div class="photoSpec">
    <div class="photoSpecBox">
      <div class="attachments">
        <span class="label">拍照规范文件:</span>
        <div class="attachmentsContent">
          <el-upload
            class="upload-demo"
            ref="upload"
            :action="attachmentsUploadUrl"
            :limit="1"
            :on-preview="handlePreview"
            :on-success="onSuccess"
            :before-remove="beforeRemove"
            :file-list="fileList"
            accept=".pdf,.jpeg"
            :data="{type: 4}"
          >
            <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
            <span class="upload-tip el-upload__tip" slot="tip">只能上传pdf,jpeg文件，且不超过500M</span>
          </el-upload>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import md5 from "md5";
import _ from "lodash";
import { downloadFile } from "@/utils/tool";

export default {
  name: "PhotoSpec",
  data() {
    const domain = window.location.origin;
    return {
      fileId: 0,
      fileName: '',
      fileList: [],
      attachmentsUploadUrl: pubServer+"/upload/upload",
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await axios.post(vmsReqUrl+"/photoStandards/list");
      res = res.data;
      if (res.code === 200) {
        const file = {
          name:  res.data.length ? res.data[0].name : '',
          url: res.data.length ? res.data[0].fileLink : '',
          id: res.data.length ? res.data[0].id : 0,
        }
        this.fileId = res.data.length ? res.data[0].id : 0
        this.fileList = res.data.length ? [file] : []
        console.log('res.data', res.data)
      }
    },

    // 成功上传文件的回调
    async onSuccess(response, file, fileList) {
      this.fileName = this.fileName || file.name
      console.log('response', response)
      console.log('file', file)
      console.log('fileList', fileList)

      let res = await axios.post(vmsReqUrl+"/photoStandards/save", {
        "fileLink": response.data.result.imageUrl,
        "name": this.fileName
      });
      res = res.data;
      if (res.code === 200) {
        this.$message.success(res.message);
        await this.getData()
      } else {
        this.$message.warning(res.message);
      }
    },

    // 删除之前
    beforeRemove () {
      this.$confirm("确认删除吗？", "提示",{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async() => {
          this.onRemove()
          return false
        })
        .catch(_ => {
          this.getData()
          return false
        })
    },

    // 删除文件的回调
    async onRemove(file, fileList) {
      console.log('删除')
      if(!!this.fileId) {
        let res = await axios.post(vmsReqUrl+"/photoStandards/delete/" + this.fileId);
        res = res.data
        if (res.code === 200) {
          this.$message.success(res.message)
          this.fileName = ''
        } else {
          this.$message.error(res.message)
        }
      } else {
        this.fileName = ''
      }
    },

    // 下载文件
    handlePreview(file) {
      console.log(file);
      const fileUrl = file.url || file.docUrl
      downloadFile(fileUrl, file.name);
      window.open(fileUrl)
    },
  }
};
</script>
<style lang="sass" scoped>
.photoSpec
  min-width: 800px
  .photoSpecBox
    padding: 20px
    width: 800px
    .upload-tip
      margin-left: 10px
  .attachments
    display: flex
    margin-bottom: 20px
    .label
      text-align: right
      width: 100px
      vertical-align: middle
      float: left
      font-size: 14px
      color: #606266
      line-height: 36px
      padding: 0 12px 0 0
      -webkit-box-sizing: border-box
      box-sizing: border-box
      flex-shrink: 0
    .attachmentsContent
      line-height: 36px
      width: 100%
  footer
    padding-top: 20px
    text-align: center



</style>



// WEBPACK FOOTER //
// src/vms/pages/views/photoSpec.vue